export default function IconGantMinus () {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.75" y="0.75" width="10.5" height="10.5" rx="2.25" stroke="#D5DCDF"/>
      <path d="M6.61043 5.39062H8.76771V6.61141H6.61043H5.38965H3.23236V5.39062H5.38965H6.61043Z" fill="#D5DCDF"/>
    </svg>
  )
}
